const input = {
    username: 'نام کاربری',
    password: 'رمز عبور',
    email: 'ایمیل',
    phone_number: 'شماره تلفن',
    confirm_password: 'تأیید رمز عبور',
    search_region_code: 'جستجوی کد منطقه',
    backup_code: 'کد پشتیبان',
    code: 'کد',
    label_with_optional: '{{label}} (اختیاری)',
    email_address: 'نشانی ایمیل',
    email_placeholder: 'ایمیل خود را وارد کنید',
    enter_email: 'ایمیل را وارد کنید',
};
export default Object.freeze(input);
